import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_cycle_pivot_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  company_name: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  claim_type: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  claim_id: fromDatatype.VarcharDatatypeInterface;
  claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_name: fromDatatype.VarcharDatatypeInterface;
  claim_amount: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  fiscal_period_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_cycle_pivot_report_line_RowClass implements bl_aat_claim_cycle_pivot_report_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_cycle_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  company_name: fromDatatype.VarcharDatatypeInterface;
  ccy_code: fromDatatype.VarcharDatatypeInterface;
  claim_type: fromDatatype.VarcharDatatypeInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  branch_name: fromDatatype.VarcharDatatypeInterface;
  employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
  employee_name: fromDatatype.VarcharDatatypeInterface;
  claim_id: fromDatatype.VarcharDatatypeInterface;
  claim_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_item_name: fromDatatype.VarcharDatatypeInterface;
  claim_amount: fromDatatype.NumericDatatypeInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  fiscal_period_hdr_guid: fromDatatype.GuidDataFieldInterface;
  fiscal_period_name: fromDatatype.VarcharDatatypeInterface;
}
